class RechargeWidget {
  constructor(el) {
    this.el = el;
    this.input = el.querySelector('input[name="selling_plan"]');
    this.value = this.input ? this.input.value : "";
    this.inputs = this.input ? [this.input] : [];
    this.currentValue = this.value;
    this.select = el.querySelector("[data-recharge-select]");
    this.selectLabel = el.querySelector("[data-recharge-select-label]");
    this.optionContainer = el.querySelector("[data-recharge-option-container]");
    this.sellingPlanOptions = el.querySelectorAll("[data-recharge-option]");
    this.widgetContainer = el.closest("[data-widget-container]");
    this.purchaseCard = this.widgetContainer?.querySelector(".recharge-toggle-card");
    this.purchaseToggle = this.widgetContainer?.querySelector("[data-purchase-toggle]");
    this.purchaseTypeInput = this.widgetContainer?.querySelector("[data-purchase-type-input]");
    this.purchaseTitle = this.widgetContainer?.querySelector("[data-purchase-title]");
    this.comparePrice = this.widgetContainer?.querySelector("[data-compare-price]");
    this.primaryPrice = this.widgetContainer?.querySelector("[data-primary-price]");
    this.firstRechargeBenefit = this.widgetContainer?.querySelector(
      ".recharge-toggle-card__content .recharge-benefit-item span:not(.recharge-benefit-icon)"
    );
    this.thirtyDaysCallout = this.optionContainer?.getAttribute("data-thirty-days-callout") || null;
    this.sixtyDaysCallout = this.optionContainer?.getAttribute("data-sixty-days-callout") || null;
    this.ninetyDaysCallout = this.optionContainer?.getAttribute("data-ninety-days-callout") || null;
    this.initialFirstRechargeBenefitText = this.firstRechargeBenefit?.textContent?.trim() || "";
  }

  init() {
    this.initRecharge();
    this.initPdpWidget();
  }

  initRecharge() {
    if (this.currentValue) {
      this.updateLocation(this.currentValue);

      if (this.firstRechargeBenefit) {
        const selectedOptionName = Array.from(this.sellingPlanOptions).find((option) => option.getAttribute("data-value") === this.currentValue)?.getAttribute("data-name");
        this.applyFirstRechargeBenefitFromPlanName(selectedOptionName);
      }
    }

    if (this.select && this.optionContainer) {
      this.select.addEventListener("click", () => {
        this.optionContainer.classList.toggle("active");
      });
    }

    if (this.sellingPlanOptions) {
      this.sellingPlanOptions.forEach((option) => {
        option.addEventListener("click", (e) => {
          e.preventDefault();
          const value = option.getAttribute("data-value");
          if (!value) return;

          const trimmedOptionName = option.textContent.trim();

          this.sellingPlanOptions.forEach((option) => {
            option.classList.remove("active");
          });
          option.classList.add("active");

          this.inputs.forEach((input) => {
            input.value = value;
          });
          this.value = value;
          this.currentValue = value;
          this.select?.setAttribute("data-current-value", value);

          this.updateLocation(this.currentValue);

          if (this.selectLabel) {
            this.selectLabel.textContent = trimmedOptionName;
          }

          if (this.firstRechargeBenefit) {
            this.applyFirstRechargeBenefitFromPlanName(trimmedOptionName);
          }

          this.optionContainer?.classList.remove("active");
        });
      });
    }

    document.body.addEventListener("click", (e) => {
      if (
        !e.target.closest("[data-recharge-option-container]") &&
        !e.target.closest("[data-recharge-select]")
      ) {
        this.optionContainer?.classList.remove("active");
      }
    });
  }

  updateLocation(value) {
    const params = new URLSearchParams(location.search);
    if (value) {
      params.set("selling_plan", value);
    } else {
      params.delete("selling_plan");
    }

    const qs = params.toString();
    window.history.replaceState({ path: value }, "", `${location.pathname}${qs ? "?" + qs : ""}${location.hash}`);
  }

  updateFirstRechargeBenefit(callout) {
    if (this.firstRechargeBenefit && callout) {
      this.firstRechargeBenefit.textContent = callout;
    }
  }

  getCalloutForPlanName(planName) {
    if (!planName) return null;

    const normalizedName = planName.toLowerCase();
    const dayMatch = normalizedName.match(/\b(30|60|90)\s*days?\b/);
    if (!dayMatch) return null;

    const dayCalloutMap = {
      30: this.thirtyDaysCallout,
      60: this.sixtyDaysCallout,
      90: this.ninetyDaysCallout,
    };

    return dayCalloutMap[dayMatch[1]] || null;
  }

  applyFirstRechargeBenefitFromPlanName(planName) {
    if (!this.firstRechargeBenefit) return;

    const callout = this.getCalloutForPlanName(planName);
    if (callout) {
      this.updateFirstRechargeBenefit(callout);
    } else if (this.initialFirstRechargeBenefitText) {
      this.firstRechargeBenefit.textContent = this.initialFirstRechargeBenefitText;
    }
  }

  setPurchaseMode(isSubscription) {
    if (!this.purchaseCard) return;

    if (isSubscription && !this.currentValue && this.select?.getAttribute("data-current-value")) {
      this.currentValue = this.select.getAttribute("data-current-value");
    }

    this.purchaseCard.setAttribute("data-purchase-mode", isSubscription ? "subscription" : "one-time");
    if (this.purchaseTypeInput) {
      this.purchaseTypeInput.value = isSubscription ? "subscription" : "one-time";
    }

    if (this.purchaseTitle) {
      const title = isSubscription
        ? this.purchaseTitle.getAttribute("data-subscription-title")
        : this.purchaseTitle.getAttribute("data-onetime-title");
      if (title) this.purchaseTitle.textContent = title;
    }

    if (this.primaryPrice && this.comparePrice) {
      const subscriptionPrice = this.purchaseCard.getAttribute("data-subscription-price");
      const onetimePrice = this.purchaseCard.getAttribute("data-onetime-price");
      const compareAtPrice = this.purchaseCard.getAttribute("data-compare-at-price");
      const compareCents = Number(this.purchaseCard.getAttribute("data-compare-at-price-cents"));
      const primaryCents = Number(
        this.purchaseCard.getAttribute(isSubscription ? "data-subscription-price-cents" : "data-onetime-price-cents")
      );
      this.primaryPrice.textContent = isSubscription ? subscriptionPrice : onetimePrice;
      const showCompare = compareAtPrice && compareCents > primaryCents;
      this.comparePrice.style.display = showCompare ? "" : "none";
      if (showCompare) this.comparePrice.textContent = compareAtPrice;
    }

    if (isSubscription) {
      this.inputs.forEach((input) => {
        input.value = this.currentValue;
      });
      this.value = this.currentValue;
      this.updateLocation(this.currentValue);
    } else {
      this.inputs.forEach((input) => {
        input.value = "";
      });
      this.value = "";
      this.updateLocation("");

      if (this.firstRechargeBenefit) {
        this.updateFirstRechargeBenefit(this.initialFirstRechargeBenefitText);
      }
    }

    document.querySelectorAll("[data-price-update-el]").forEach((priceEl) => {
      const nextPrice = isSubscription
        ? this.purchaseCard.getAttribute("data-subscription-price")
        : this.purchaseCard.getAttribute("data-onetime-price");
      if (nextPrice) priceEl.innerHTML = nextPrice;
    });
  }

  initPdpWidget() {
    const form = this.el.closest("form[data-product-form]");
    if (!form) return;

    const toggle = this.widgetContainer?.querySelector("[data-purchase-toggle]");
    const gwpInputs = form.querySelectorAll('[data-gwp-property]');

    const toggleGwp = () => {
      const isSub = Boolean(toggle?.checked);
      gwpInputs.forEach((input) => {
        input.disabled = !isSub;
      });
    };

    if (!toggle) return;

    this.setPurchaseMode(toggle.checked);
    toggle.addEventListener("change", () => {
      this.setPurchaseMode(toggle.checked);
      toggleGwp();
    });

    toggleGwp();
  }
}

